import { IsString, IsNotEmpty, IsOptional, IsBoolean, IsNumber, Min } from 'class-validator';

export class OrganisationPublicInfo {
    /** Used as a franchiser identifier */
    @IsString()
    @IsNotEmpty()
    public readonly franchiserName: string;

    @IsOptional()
    @IsString()
    public readonly organisationLogo?: string;

    @IsOptional()
    @IsString()
    public readonly organisationBankPaymentQr?: string;

    @IsOptional()
    @IsString()
    public readonly tinkoffKassaMerchantToken?: string;

    @IsOptional()
    @IsBoolean()
    public readonly yooKassaEnabled?: boolean;

    @IsOptional()
    @IsNumber()
    public readonly minProfileLineLength?: number;

    @IsOptional()
    @IsBoolean()
    public readonly noVAT?: boolean;

    @IsOptional()
    @IsBoolean()
    public readonly showDeliveryCalculator?: boolean;

    @IsOptional()
    @IsString()
    public readonly billingPublicUrl?: string;

    @IsOptional()
    @IsBoolean()
    public readonly isRegistrationPageEnabled?: boolean;

    @IsOptional()
    @IsBoolean()
    public readonly greenApiChatEnabled?: boolean;

    @IsOptional()
    @IsString()
    public readonly palantirPublicUrl?: string;

    @IsOptional()
    @IsString()
    public readonly cuttingServiceLink?: string;

    @IsOptional()
    @IsNumber()
    @Min(1)
    public readonly priceFixationPeriodDays?: number;

    constructor(data?: Partial<OrganisationPublicInfo>) {
        this.franchiserName = data?.franchiserName || '';
        this.organisationLogo = data?.organisationLogo || '';
        this.organisationBankPaymentQr = data?.organisationBankPaymentQr || '';
        this.tinkoffKassaMerchantToken = data?.tinkoffKassaMerchantToken || '';
        this.yooKassaEnabled = data?.yooKassaEnabled || false;
        this.minProfileLineLength = data?.minProfileLineLength || 10;
        this.noVAT = data?.noVAT || false;
        this.showDeliveryCalculator = data?.showDeliveryCalculator || false;
        this.billingPublicUrl = data?.billingPublicUrl || '';
        this.isRegistrationPageEnabled = data?.isRegistrationPageEnabled || false;
        this.greenApiChatEnabled = data?.greenApiChatEnabled || false;
        this.palantirPublicUrl = data?.palantirPublicUrl || '';
        this.cuttingServiceLink = data?.cuttingServiceLink || '';
        this.priceFixationPeriodDays = data?.priceFixationPeriodDays || 10;
    }
}
